export default __webpack_public_path__ + "static/media/ORFI0N0.860b94ea.jpg";